import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import AddMoreBanner from "../banners/addMoreBanner";
import RemoveBannerImg from "../banners/removeBannerImg";
import UpdateBannerImg from "../banners/updateBannerImg";
import Table from "../../../components/table";
import BannerPreview from "./bannerPreview";
import {
  fetchCms,
  uploadCms,
  updateCms,
  deleteCms,
  API_BASE_URL,
} from "../../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader";
import toast from "react-hot-toast";

const Banners = () => {
  const [banners, setBanners] = useState();
  const [loading, setLoading] = useState(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState(0);
  const [selectedImgUrl, setSelectedImgUrl] = useState("")
  const [isAddMoreOpen, setIsAddMoreOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchCms, {
        params: { type: "BANNER" },
        headers: { Authorization: `Bearer ${auth}` },
      });
      const images = response?.data?.map((banner) => ({
        sequence: banner?.sequence,
        imgUrl: `${API_BASE_URL}public/images/${banner?.fileName}`,
        id: banner?.id,
      }));
      setBanners(images);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const uploadAndSaveImg = async (img, type) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", img);
      const uploadResponse = await axios.post(uploadCms, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadResponse.status === 200) {
        let fileName = uploadResponse.data.message;
        fileName = fileName?.split("/")?.pop();
        try {
          let payload = {
            fileName,
            imageType: "BANNER",
          };

          let response;

          if (type == "update") {
            // payload = {
            //   ...payload,
            //   sequence: selectedSequence
            // }
            response = await axios.post(updateCms, payload, {
              params: { id: selectedImg },
              headers: { Authorization: `Bearer ${auth}` },
            });
          } else {
            response = await axios.post(updateCms, payload, {
              headers: { Authorization: `Bearer ${auth}` },
            });
          }

          if (response.status === 200) {
            toast.success("Image saved successfully");
            fetchBanners();
          }
        } catch (error) {
          toast.error("Error saving image to DB");
          console.error("Error saving image to DB:", error);
        }
      }
    } catch (error) {
      toast.error("Error uploading image");
      console.error("Error uploading image:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteBannerCms = async () => {
    try {
      setLoading(true)
      const response = await axios.delete(deleteCms, {
        params: { id: selectedImg },
        headers: { Authorization: `Bearer ${auth}` },
      });
      if (response?.status == 200) {
        toast.success("Banner deleted");
        fetchBanners();
      }
    } catch (error) {
      toast.error("Error deleting banner");
      console.error("Error deleting banner", error);
    } finally {
      setLoading(false)
    }
  };

  const openUpdateModal = (bannerId, imgUrl) => {
    setSelectedImg(bannerId);
    setSelectedImgUrl(imgUrl);
    setIsUpdateOpen(true);
  };

  const openRemoveModal = (bannerId, imgUrl) => {
    setSelectedImg(bannerId);
    setSelectedImgUrl(imgUrl);
    setIsRemoveOpen(true);
  };

  const getActionButtons = (id, imgUrl) => {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <button className="btn p-0 me-2" onClick={() => openUpdateModal(id, imgUrl)}>
          <FaRegEdit size={26} />
        </button>
        <button className="btn p-0" onClick={() => openRemoveModal(id, imgUrl)}>
          <AiOutlineDelete size={26} />
        </button>
      </div>
    );
  };

  const headings = [
    {
      name: "Sequence No.",
      fieldName: "sequence",
      isSortable: true,
      sortKey: "none",
    },
    // { name: "ID", fieldName: "id", isSortable: false, sortKey: "none" },
    { name: "Image", fieldName: "img", isSortable: false, sortKey: "none" },
    {
      name: "Actions",
      fieldName: "actions",
      isSortable: false,
      sortKey: "none",
    },
  ];

  const tableRows = banners?.map((img, index) => ({
    sequence: img?.sequence,
    id: img?.id,
    img: (
      <img
        src={img?.imgUrl}
        alt={`Carousel ${index + 1}`}
        style={{ height: "10rem" }}
      />
    ),
    actions: () => getActionButtons(img?.id, img?.imgUrl),
  }));

  return (
    <div>
      {/* <div className="d-flex justify-content-end mb-3 gap-3"> */}
        {/* <Button text="Carousel Preview" callBack={openCarouselPreview} /> */}
        {/* <Button text="+ Add More" callBack={() => setIsAddMoreOpen(true)} /> */}
      {/* </div> */}
      <Table headings={headings} data={tableRows} enablePagination={false} addBtnText="+ Add Banner" addCallback={() => setIsAddMoreOpen(true)} card={true}/>
      <UpdateBannerImg
        isUpdateOpen={isUpdateOpen}
        closeUpdateModal={() => setIsUpdateOpen(false)}
        uploadAndSaveImg={uploadAndSaveImg}
        selectedImgUrl={selectedImgUrl}
      />
      <RemoveBannerImg
        isRemoveOpen={isRemoveOpen}
        closeRemoveModal={() => setIsRemoveOpen(false)}
        deleteBannerCms={deleteBannerCms}
        selectedImgUrl={selectedImgUrl}
      />
      <AddMoreBanner
        isAddMoreOpen={isAddMoreOpen}
        closeAddMoreModal={() => setIsAddMoreOpen(false)}
        uploadAndSaveImg={uploadAndSaveImg}
      />
      <BannerPreview
        preview={preview}
        closePreviewModal={() => setPreview(false)}
        bannerImages={banners}
      />
      {loading && <Loader />}
    </div>
  );
};

export default Banners;
